import {parseParam, replaceDynamicParameter} from '../index';
import {DYNAMIC_PARAMETER_TYPE} from '../constant';
import {isEqual, isNaN, pullAt, toNumber,round} from 'lodash'

export const lodashSet = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 3) {
    let data = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let key = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    let value = await parseParam(_get(func, 'inParams')[2], customParamsList, customFunctionParams, instanceId);
    _set(data, key, value);
    return data;
  }
}

export const lodashGet = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let data = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let key = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    // console.log("lodashGet----", data, key, _get(data, key));
    return _get(data, key);
  }
}

/**
 * 获取数组的长度
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const lodashSize = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 1) {
    let data = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    return _size(data);
  }
}

/**
 * 获取数组的第一个元素
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const lodashHead = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 1) {
    let data = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    return _head(data);
  }
}

/**
 * 获取数组的最后一个元素
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const lodashLast = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 1) {
    let data = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    return _last(data);
  }
}

export const lodashForEach = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    const callbackValueList = []
    let data = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    for (const item of data) {
      const index = data.indexOf(item);
      let customParamsListCopy = _cloneDeep(customParamsList);
      replaceDynamicParameter(customParamsListCopy, DYNAMIC_PARAMETER_TYPE.CURRENT_ITEM, item);
      replaceDynamicParameter(customParamsListCopy, DYNAMIC_PARAMETER_TYPE.CURRENT_INDEX, index);
      const callbackValue = await parseParam(_get(func, 'inParams')[1], customParamsListCopy, customFunctionParams, instanceId);
      if (callbackValue) {
        callbackValueList.push(callbackValue);
      }
    }
    return callbackValueList;
  }
}

export const lodashPush = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let data = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let value = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    data.push(value);
    return data;
  }
}

export const lodashFilter = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let data = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let dataCopy = [];
    for (let item of data) {
      let customParamsListCopy = _cloneDeep(customParamsList);
      replaceDynamicParameter(customParamsListCopy, DYNAMIC_PARAMETER_TYPE.CURRENT_ITEM, item);
      if (await parseParam(_get(func, 'inParams')[1], customParamsListCopy, customFunctionParams, instanceId)) {
        dataCopy.push(item);
      }
    }
    return dataCopy;
  }
}

export const lodashRemove = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let dataList = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let targetObject = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    _remove(dataList, (item: any) => isEqual(item, targetObject));
    return dataList;
  }
}

export const lodashPullAt = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let dataList = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let targetObject = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    let num = toNumber(targetObject)
    if (!isNaN(num)) {
      return pullAt(dataList, num);
    }
    return dataList;
  }
}

export const lodashSumBy = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let dataList = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let targetObjectKey = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    return _sumBy(dataList, targetObjectKey);
  }
}

export const lodashMeanBy = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let dataList = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let targetObjectKey = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    return _meanBy(dataList, targetObjectKey);
  }
}

export const lodashMaxBy = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let dataList = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let targetObjectKey = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    return _maxBy(dataList, targetObjectKey);
  }
}


export const lodashMinBy = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let dataList = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let targetObjectKey = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    return _minBy(dataList, targetObjectKey);
  }
}

export const lodashCartesianProduct = async (func, customParamsList, customFunctionParams, instanceId) => {
  let list = [];
  for (let param of _get(func, 'inParams')) {
    list.push(await parseParam(param, customParamsList, customFunctionParams, instanceId));
  }
  return cartesianProductImpl(list);
}

export const cartesianProductImpl = (arrays: [][]) => {
  return arrays.reduce((acc, curr) => {
    return acc.flatMap(accItem => {
      return curr.map(currItem => {
        // @ts-ignore
        return {...accItem, ...currItem};
      });
    });
  }, [{}]);
}

/**
 * 处理值转换精度
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const lodashRound = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 2) {
    let valueRaw = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    let precisionDigitRaw = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    let value = Number(valueRaw);
    if (isNaN(value)) value = 0;

    // 处理精度位数，非法则默认0
    let precisionDigit = Number(precisionDigitRaw);
    if (isNaN(precisionDigit)) precisionDigit = 0;
    return round(value, precisionDigit);
  }
}



